// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//= require cocoon
require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require('font-awesome/css/font-awesome.css')
require("jquery")
require('cocoon-rails/src/cocoon')
require('chart.js/dist/Chart')
require('materialize-css/dist/js/materialize')
require('../stylesheets/application')
require("trix")
require("@rails/actiontext")
require('packs/dashboards')
require('packs/relateds')
require('packs/banner')
require('packs/users')
import 'packs/select2'
require('packs/resources')

import Quill from "quill";
import * as Emoji from "quill-emoji";
import BlotFormatter from "quill-blot-formatter";
import ImageCompress from 'quill-image-compress';

Quill.register("modules/emoji", Emoji);
Quill.register("modules/blotFormatter", BlotFormatter);
Quill.register('modules/imageCompress', ImageCompress);

import "quill/dist/quill.snow.css";
import "quill-emoji/dist/quill-emoji.css";


  // disable rich text attachment
  window.addEventListener("trix-file-accept", function(event) {
    event.preventDefault();
    alert("No se pueden subir archivos!")
  })

$(document).on('turbolinks:load',function(){

  M.AutoInit();  
  $('.carousel').carousel({
    dist: -1,
    numVisible: -1,
    fullWidth: false,
    padding: 500,
  });

  autoplay();

  function autoplay() {
    $('.carousel').carousel('next');
    setTimeout(autoplay, 5000);
  }

  $(".dropdown-trigger").dropdown({
    coverTrigger: false
  });

  $('tab').on('click', function(e){
    e.preventDefault()
  })

  $('.tabs').tabs()

  $('.dropdown-trigger').on('click', function(e){
    e.preventDefault()
  });

  $('.sidenav-trigger').on('click', function(e){
    e.preventDefault()
    $('.sidenav').sidenav('open');
  });

  $(".sidenav ul.collapsible").hover(
    function(e){
      $(e.currentTarget).find('.collapsible-body').show()
    },
    function(e){
      $(e.currentTarget).find('.collapsible-body').hide()
    }
  );

  initializeAllQuillEditors();
});

$(document).on("turbolinks:before-cache", function() {
  if ($('select').length) {
    $('select').formSelect("destroy")
  }
  $(".dropdown-trigger").dropdown({
    coverTrigger: false
  });
});


window.alert_notification = function(notify){
  return M.toast({html: notify})
}

window.notice_notification = function(notice){
  return M.toast({html: notice})
}

window.initializeAllQuillEditors = function() {
  document.querySelectorAll(".quill-editor").forEach((editor) => {
    console.log(editor.id)
    initializeQuillEditor(editor.id);
  });
}

window.initializeQuillEditor = function(elementID) {
  let hiddenInput = document.querySelector(`#${elementID.replace("_editor", "_content")}`);
  let quill = new Quill(`#${elementID}`, {
    theme: "snow",
    modules: {
      toolbar: [
        // [{ header: [1, 2, false] }],
        // ["bold", "italic", "underline"],
        // [{ list: "ordered" }, { list: "bullet" }],
        // ["link", "image", "video"],
        
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        ['link', 'image', 'video'],

        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'align': [] }, { 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

        // [{ 'size': ['small', false, 'large', 'Extra large'] }],  // custom dropdown

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }, { 'header': [1, 2, 3, 4, 5, 6, false] }],

        ['clean'],
        ["emoji"],
      ],
      blotFormatter: {},
      imageCompress: {
        quality: 1,
        maxWidth: 1200,
        debug: false,
        suppressErrorLogging: true,
      },
      "emoji-toolbar": true,
      "emoji-shortname": true,
    },
  });

  // Si hay contenido existente, lo carga en Quill
  quill.root.innerHTML = hiddenInput.value;

  // Actualiza el input hidden cuando cambia el editor
  quill.on("text-change", function () {
    hiddenInput.value = quill.root.innerHTML;
  });  
}
